import { type PortableTextComponentProps } from '@portabletext/react'
import cx from 'classnames'
import { useState, useContext } from 'react'

import { type SanityAddToCartButton } from '@data/sanity/queries/types/content'
import { StringsContext } from '@lib/strings-context'

import BaseAddToCartButton from '@components/buttons/add-to-cart-button'
import Alert from '@components/alert'
import {
  getButtonColor,
  getButtonIconAlignment,
  getButtonSize,
  getButtonVariant,
} from '@components/buttons/button'
import SimplePortableText from '@components/simple-portable-text'

type AddToCartButtonValue = Pick<
  SanityAddToCartButton,
  'productVariant' | 'style' | 'text'
>

const AddToCartButton = ({
  value,
}: PortableTextComponentProps<AddToCartButtonValue>) => {
  const {
    productVariant,
    text,
    style: { variant, size, color, icon, iconAlignment, isFullWidth },
  } = value

  const strings = useContext(StringsContext)

  const [isAddToCartError, setIsAddToCartError] = useState(false)

  return (
    <div className="space-y-3">
      <BaseAddToCartButton
        productVariant={productVariant}
        variant={getButtonVariant(variant)}
        size={getButtonSize(size)}
        color={getButtonColor(color)}
        icon={icon}
        iconAlignment={getButtonIconAlignment(iconAlignment)}
        onAddToCartError={() => setIsAddToCartError(true)}
        buttonClassName={cx({
          'w-full': isFullWidth,
        })}
      >
        {text}
      </BaseAddToCartButton>

      {isAddToCartError && (
        <div key="error">
          <Alert error className="rc rc-alert rc-error">
            <SimplePortableText content={strings.cartAddToCartErrorMessage} />
          </Alert>
        </div>
      )}
    </div>
  )
}

export default AddToCartButton
